// src/lib/config/env.ts
interface AppConfig {
  VITE_APP_BASE_URL: string;
  VITE_APP_FRONTEND_URL: string;
  VITE_APP_NEWRELIC_APIKEY: string;
  VITE_APP_PUSHER_CHANNEL: string;
  VITE_APP_PUSHER_API_KEY: string;
  VITE_APP_PUSHER_CLUSTER: string;
  version: string;
  [key: string]: string | undefined;
}

// Declare window.appConfig in global scope
declare global {
  interface Window {
    appConfig: Partial<AppConfig>;
  }
}

// Static configuration values
const STATIC_CONFIG: AppConfig = {
  VITE_APP_BASE_URL: "https://dev.api.veiligh.com",
  VITE_APP_FRONTEND_URL: "",
  VITE_APP_NEWRELIC_APIKEY: "your_newrelic_key_here",
  VITE_APP_PUSHER_CHANNEL: "veiligh-channel",
  VITE_APP_PUSHER_API_KEY: "652c144faa9276552cb5",
  VITE_APP_PUSHER_CLUSTER: "eu",
  version: "0.0.0",
};

let runtimeConfig: AppConfig | null = null;

export async function loadConfig(): Promise<void> {
  if (typeof window === "undefined") return;

  return new Promise<void>((resolve) => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.async = true;
    script.onload = () => {
      runtimeConfig = {
        ...STATIC_CONFIG,
        ...window.appConfig,
      };

      resolve();
    };
    script.onerror = () => {
      console.warn("⚠️ Failed to load config.js. Using STATIC_CONFIG.");
      runtimeConfig = { ...STATIC_CONFIG };
      resolve();
    };
    document.head.appendChild(script);
  });
}

export function getConfig(): AppConfig {
  if (!runtimeConfig) {
    // Fallback to static config if not loaded
    return { ...STATIC_CONFIG };
  }

  return runtimeConfig as AppConfig;
}

// Initialize config automatically in browser context
if (typeof window !== "undefined") {
  loadConfig().catch(console.error);
}
